// extracted by mini-css-extract-plugin
module.exports = {"step":"QuickStart_step__2SlzC","numeration":"QuickStart_numeration__3p3EP","paragraph":"QuickStart_paragraph__9SVOh","filter":"QuickStart_filter__1tweJ"};